import { getLocale } from "../runtime";

const sv_dkcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Danmark`
};

const dkcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_dkcountry(inputs)
	return "dkCountry";
};

export { dkcountry as "dkCountry" };